import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import OptionsCard from "../../../Components/Card/AssetUI/OptionsCard";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const MCQ = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  const [userAnswer, setUserAnswer] = useState([]);
  const [logObj, setLogObj] = useState(initLogObj);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } = useSelector(
    (state) => state.currentAsset
  );

  useEffect(() => {
    if (props.content) {
      setUserAnswer(
        new Array(props.content.epage.options.content.length).fill(false)
      );
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData(
          new Array(props.content.epage.options.content.length).fill(null)
        )
      );
      let actualAnswers = props.content.epage.options.content.map((val) => {
        if (val.answer) return JSON.parse(val.answer);
        else return JSON.parse("false");
      });
      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswers,
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
  }, [logObj]);

  useEffect(() => {
    setUserAnswer(
      new Array(props.content.epage.options.content.length).fill(false)
    );
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(
      currentAssetSliceActions.setCurrentAttemptData(
        new Array(props.content.epage.options.content.length).fill(false)
      )
    );
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      setUserAnswer(assetLogObj.actualAnswer);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const updateUserAnswer = (index) => {
    let newArray = [...userAnswer];
    if (
      (!newArray[index] || newArray[index] == "false") &&
      newArray.filter((val) => {
        return val || val == "true";
      }).length >=
        newArray.length - 1
    ) {
      return false;
    }
    if (!showAnswer && !attempted) {
      newArray[index] = !newArray[index];
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  return (
    <div  >
      {props.content &&
        props.content.epage.options.content.map((item, index) => {
          return (
            <OptionsCard
              text={item.text}
              media={item.media}
              index={index}
              totalOptions={props.content.epage.options.content.length}
              selected={userAnswer[index]}
              press={(selectedIndex) => {
                updateUserAnswer(selectedIndex);
              }}
              assetType={props.content.info.asset_type_alias}
              optionWiseAns={optionWiseAns[index]}
            />
          );
        })}
    </div>
  );
};

const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
    "@media (min-width: 1636px)": {
      fontSize: "1.4rem",
    },
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "62vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default MCQ;
